<template>
  <div class="t-lk-course-content" v-if="course">
    <div class="t-lk-course-content__wrap" v-if="course.constructor.length">
      <div class="t-lk-course-content__builder" v-for="item in course.constructor" :key="item.type">
        <h3 v-if="item.type === 'builder_header'" class="t-lk-course-content__title" v-html="item.content.title"></h3>
        <p v-if="item.type === 'builder_text'" class="t-lk-course-content__content" v-html="item.content.text"></p>
        <lk-video-cmp v-if="item.type === 'builder_video' && item.content.src" :video="item.content.src" />
      </div>
    </div>
    <div class="t-lk-course-content__wrap" v-if="course.files.length">
      <h3 class="t-lk-course-content__subtitle">{{ $root.staticText.lk.materialsOnlineCoursesSubtitleFiles }}</h3>
      <ul class="t-lk-course-content__list">
        <a class="t-lk-course-content__item" v-for="file in course.files" :key="file.id" :href="file.link" download>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.33317 28H22.6665C23.3738 28 24.052 27.719 24.5521 27.219C25.0522 26.7189 25.3332 26.0406 25.3332 25.3333V12.552C25.3331 12.1984 25.1926 11.8593 24.9425 11.6093L17.7238 4.39067C17.4738 4.1406 17.1348 4.00008 16.7812 4H9.33317C8.62593 4 7.94765 4.28095 7.44755 4.78105C6.94746 5.28115 6.6665 5.95942 6.6665 6.66667V25.3333C6.6665 26.0406 6.94746 26.7189 7.44755 27.219C7.94765 27.719 8.62593 28 9.33317 28Z"
              stroke="#00b0bd"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="t-lk-course-content__file-info">
            <div class="t-lk-course-content__head">
              <h3 class="t-lk-course-content__name">{{ file.name }}</h3>
              <p class="t-lk-course-content__download">{{ $root.staticText.lk.materialsOnlineCoursesDownload }}</p>
            </div>
            <p class="t-lk-course-content__file-desc">
              <span class="_decor">{{ file.type }}</span>
              <span>{{ file.size }}</span>
            </p>
          </div>
        </a>
      </ul>
    </div>
  </div>
</template>

<script>
import lkVideo from '@components/lk/lk-video/lk-video'
export default {
  name: 'lk-course-content',
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    'lk-video-cmp': lkVideo,
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-course/lk-course-content/lk-course-content.vue